


























import { Component, Prop } from "vue-property-decorator";
import { BaseInputComponent } from ".";

@Component({
  components: {},
})
export default class InputFileCpt extends BaseInputComponent {
  @Prop() autofocus?: boolean;
  @Prop({ default: ".csv" }) accept: string;
  @Prop({ default: false }) clearable: boolean;
  @Prop({ default: false }) multiple: boolean;
  @Prop({ default: false }) readonly: boolean;
  @Prop({ required: false, default: null }) bind: any;
  @Prop({ required: false, default: null }) on: any;

  clearValue() {
    if (this.clearable) {
      this.$emit("clear");
    }
  }

  onChangedInternal(value: any) {
    this.onChange(value);
  }
}
